import { useDispatch, useSelector } from "react-redux";
import styles from "src/components/molecules/TabLinks/styles.module.css";
import { RootState } from "src/store";
import {
  setEvenetFilterSize,
  setEventType,
} from "src/store/events/eventsSlice";
import { FilterEvent } from "src/types/api";
import cx from "classnames";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { PAGES } from "src/types/navigation";
import { useRedirect } from "src/navigation/useRedirect";
import { DEFAULT_EVENT_SIZE } from "src/constants/size";
import { useGetEventsFilter } from "src/queries/useGetEventsFilter";
import { DictionaryKey } from "src/types/language";
import { Msg } from "src/i18n/Msg";
type Link = {
  titleTranslate?: DictionaryKey;
  value: number | undefined;
  title?: string;
};

const allLinks: Link[] = [
  {
    titleTranslate: "components.templates.CabinetTemplate.all",
    value: undefined,
  },
];

export const TabLinks = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { redirect } = useRedirect();
  const { data } = useGetEventsFilter();
  const tabRefs = useRef<Record<string, HTMLParagraphElement | null>>({});
  const isNottRootPage = pathname !== PAGES.ROOT;
  const eventType = useSelector((state: RootState) => state.events.eventType);
  const handleClick = (value: number | undefined) => {
    if (isNottRootPage) {
      redirect({ scheme: PAGES.ROOT });
    }
    dispatch(setEventType(value));
    dispatch(setEvenetFilterSize(DEFAULT_EVENT_SIZE));
  };
  useEffect(() => {
    const activeRef = tabRefs.current[eventType!];
    if (activeRef) {
      activeRef.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [eventType]);
  const links: Link[] =
    data?.data?.filters?.map((link: FilterEvent) => ({
      value: link.id,
      title: link.title,
    })) ?? [];
  const filters = [...allLinks, ...links];
  return (
    <div className={styles.tabLinks}>
      {filters?.map((link) => (
        <p
          ref={(el) => {
            tabRefs.current[link.value!] = el;
          }}
          key={link.value}
          role="button"
          className={cx({
            [styles.activeLink]: link.value === eventType,
          })}
          onClick={() => handleClick(link.value)}
        >
          {link.titleTranslate ? <Msg id={link.titleTranslate} /> : link.title}
        </p>
      ))}
    </div>
  );
};
